"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("@airasia/phoenix-components/components/Modal"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AmenitiesCard = _interopRequireDefault(require("@airasia/phoenix-components/components/AmenitiesCard"));
var _RoomCard = require("../RoomCard/RoomCard.propTypes");
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _constant = require("@airasia/phoenix-components/components/AmenitiesCard/constant");
var _constants = require("./constants");
var AllAmenitiesModalWrapper = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__AllAmenitiesModalWrapper",
  componentId: "sc-99sefe-0"
})(["#airasia-phoenix-modal-content{margin-top:", ";padding:", ";background-color:", ";}font-family:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.none;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.none;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.backgroundColor.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
});
var AllAmenitiesModalHeader = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__AllAmenitiesModalHeader",
  componentId: "sc-99sefe-1"
})(["box-shadow:0px 2px 6px rgba(0,0,0,0.2);padding:", ";display:flex;align-items:center;"], function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.medium, " ").concat(theme.space.normal);
});
var BackButton = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__BackButton",
  componentId: "sc-99sefe-2"
})(["margin-right:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.normal;
});
var Title = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__Title",
  componentId: "sc-99sefe-3"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral;
});
var AllAmenitiesModalContent = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__AllAmenitiesModalContent",
  componentId: "sc-99sefe-4"
})(["padding:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.small;
});
var HeroImage = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__HeroImage",
  componentId: "sc-99sefe-5"
})(["height:111px;margin-bottom:", ";position:relative;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.mini;
});
var RoomInfo = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__RoomInfo",
  componentId: "sc-99sefe-6"
})(["border-bottom:", ";"], function (_ref13) {
  var theme = _ref13.theme;
  return "1px solid ".concat(theme.colors.greyLight);
});
var RoomName = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__RoomName",
  componentId: "sc-99sefe-7"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontSize.titleSmall;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeight.medium;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.lineHeight.XXLarge;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.black;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.micro;
});
var Address = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__Address",
  componentId: "sc-99sefe-8"
})(["font-size:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSize.XSmall;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.lineHeight.small;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.greyDarker;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.micro;
});
var At = _styledComponents.default.span.withConfig({
  displayName: "AllAmenitiesModal__At",
  componentId: "sc-99sefe-9"
})(["color:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.greyDark;
});
var ViewsRoomImages = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__ViewsRoomImages",
  componentId: "sc-99sefe-10"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-bottom:", ";"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.fontSize.small;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontWeight.medium;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.secondary;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.small;
});
var AmenitiesWrapper = _styledComponents.default.div.withConfig({
  displayName: "AllAmenitiesModal__AmenitiesWrapper",
  componentId: "sc-99sefe-11"
})(["padding-top:", ";"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.space.small;
});
var AllAmenitiesModal = function AllAmenitiesModal(_ref30) {
  var theme = _ref30.theme,
    onClose = _ref30.onClose,
    isOpen = _ref30.isOpen,
    heroImage = _ref30.heroImage,
    name = _ref30.name,
    address = _ref30.address,
    amenities = _ref30.amenities,
    openImageGallery = _ref30.openImageGallery,
    translations = _ref30.translations,
    zIndex = _ref30.zIndex;
  var atText = translations.at,
    viewRoomImages = translations.viewRoomImages,
    amenitiesText = translations.amenitiesText,
    aboutTheRoom = translations.aboutTheRoom;
  return /*#__PURE__*/_react.default.createElement(AllAmenitiesModalWrapper, null, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    openModal: isOpen,
    zIndex: zIndex,
    theme: theme,
    showCloseIcon: false,
    fullScreen: true,
    viewPort: "full_width"
  }, /*#__PURE__*/_react.default.createElement(AllAmenitiesModalHeader, null, /*#__PURE__*/_react.default.createElement(BackButton, {
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    fontsize: "titleNormal",
    icon: "ArrowBackIcon",
    color: "greyDark"
  })), /*#__PURE__*/_react.default.createElement(Title, null, aboutTheRoom)), /*#__PURE__*/_react.default.createElement(HeroImage, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: heroImage,
    width: "100%",
    height: "100%",
    centerFocus: true,
    enableProgressiveImageLoading: true,
    lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
  })), /*#__PURE__*/_react.default.createElement(AllAmenitiesModalContent, null, /*#__PURE__*/_react.default.createElement(RoomInfo, null, /*#__PURE__*/_react.default.createElement(RoomName, null, name), address && /*#__PURE__*/_react.default.createElement(Address, null, /*#__PURE__*/_react.default.createElement(At, null, atText), " ".concat(address.city, " ").concat(address.country)), /*#__PURE__*/_react.default.createElement(ViewsRoomImages, {
    onClick: openImageGallery
  }, viewRoomImages)), /*#__PURE__*/_react.default.createElement(AmenitiesWrapper, null, /*#__PURE__*/_react.default.createElement(_AmenitiesCard.default, {
    accessible: true,
    amenities: amenities,
    title: amenitiesText,
    twoColumns: true,
    iconConstent: _constant.ICON_ROOM_AMENITIES
  })))));
};
AllAmenitiesModal.propTypes = _RoomCard.AllAmenitiesModalPropTypes;
AllAmenitiesModal.defaultProps = _RoomCard.AllAmenitiesModalDefaultValues;
var _default = AllAmenitiesModal;
exports.default = _default;